import React from "react";

const FlipbookIcon = ({ color = "#A9A9A9", ...props }) => (
  <svg
    width={120}
    height={86}
    viewBox="0 0 120 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color }}
    {...props}
  >
    <path
      d="M36.8897 43.2245H46.5821M36.8897 38.6H54.9322M36.8897 45.5936H46.5821M36.8897 49.3815H39.9187"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />

    <path
      d="M59.8546 61.433L59.9325 30.5049M59.8546 61.433H55.2622H34.5183C33.6512 61.433 32.9482 60.7301 32.9482 59.863V33.5147V28.6501C32.9482 27.7829 33.6512 27.08 34.5183 27.08H52.9609C54.784 27.08 56.5503 27.7146 57.9566 28.8748L59.9325 30.5049M59.8546 61.433H64.3954L85.5329 61.7226C86.4083 61.7346 87.1244 61.0282 87.1244 60.1527V33.4109V27.9235C87.1244 27.0564 86.4215 26.3535 85.5544 26.3535H76.1232M59.8546 61.433L61.9833 59.1301L65.5103 55.2985C66.1057 54.6517 66.7695 54.0715 67.4902 53.568C69.495 52.1673 71.8009 51.2573 74.222 50.9111L75.184 50.7736C75.7229 50.6966 76.1232 50.235 76.1232 49.6907V26.3535M59.9325 30.5049L61.2738 27.0078C61.769 25.7166 62.4219 24.4915 63.2176 23.3603L63.9161 22.3674C65.0354 20.7763 66.4727 19.4348 68.1372 18.4279C69.5064 17.5996 70.9779 16.9537 72.5144 16.5064L74.1143 16.0408C75.119 15.7483 76.1232 16.5019 76.1232 17.5482V26.3535"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeLinecap="round"
    />

    <path
      d="M91.2412 58.9951V30.2478"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeLinecap="round"
    />

    <path
      opacity={0.65}
      d="M93.7363 55.908V32.9102"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeLinecap="round"
    />

    <path
      d="M29.2588 59.2024V30.4551"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeLinecap="round"
    />

    <path
      opacity={0.65}
      d="M26.7637 56.1155V33.1177"
      stroke="currentColor"
      strokeWidth={0.898458}
      strokeLinecap="round"
    />
  </svg>
);

export default FlipbookIcon;